import { find, isInteger, isEmpty } from 'lodash';
import React from 'react';
import styled from 'styled-components';

import Avatar from '../Avatar';
import Count from '../../Common/Count';
import Name from '../Name';
import Selector from '../../Common/Selector';

const { CLASS_NAME_PREFIX } = Selector;

const PLACEHOLDER = 'Выбрать ответственного';

export interface IManagerSelector {
  className?: string;
  managers:
    | {
        avatarUrl?: string;
        label: string;
        name: string;
        unreadAmount?: number;
        value: string;
      }[]
    | null;
  onChange: (data: { value: string }) => void;
  value: string | null;
  isRequired?: boolean;
  isClearable: boolean;
}

const defaultProps: IManagerSelector = {
  className: '',
  managers: null,
  onChange: () => null,
  value: null,
  isClearable: true,
};

class ManagerSelector extends React.PureComponent<IManagerSelector> {
  static defaultProps = defaultProps;

  static getValueLabel(prop) {
    const { data, innerProps } = prop;
    const { avatarUrl, name } = data;

    return (
      <StyledValue {...innerProps}>
        <StyledAvatar name={name} url={avatarUrl} />
        <StyledName name={name} />
      </StyledValue>
    );
  }

  static customFilter({ data }, searchText) {
    const { name } = data;

    const formattedName = (name && name.toLowerCase()) || '';
    const formattedQuery = searchText && searchText.toLowerCase();

    const isMatched = formattedName.includes(formattedQuery);

    return isMatched;
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selected) {
    const { onChange } = this.props;
    const value = selected?.value || '';
    onChange({ value });
  }

  render() {
    const { managers, value, isClearable, ...props } = this.props;

    if (isEmpty(managers)) {
      return null;
    }

    const selectedManager = find(managers, { value }) || null;

    return (
      <StyledSelector
        {...props}
        components={{
          SingleValue: ManagerSelector.getValueLabel,
        }}
        isSearchable
        isClearable={isClearable}
        onChange={this.handleChange}
        filterOption={ManagerSelector.customFilter}
        options={managers}
        placeholder={PLACEHOLDER}
        value={selectedManager}
      >
        {({ data }) => {
          const { avatarUrl, name, unreadAmount } = data;
          const isValidCount = isInteger(unreadAmount) && unreadAmount > 0;

          return (
            <StyledOption>
              <StyledAvatar name={name} url={avatarUrl} />
              {name && <StyledName name={name} />}
              {isValidCount && <StyledCount value={unreadAmount} />}
            </StyledOption>
          );
        }}
      </StyledSelector>
    );
  }
}

const StyledAvatar = styled(Avatar)``;

const StyledName = styled(Name)`
  font-size: 14px;
  font-weight: 300;
`;

const StyledCount = styled(Count)`
  margin-left: auto;
`;

const StyledMangerBase = styled.div`
  align-items: center;
  display: flex;
`;

const StyledOption = styled(StyledMangerBase)`
  align-items: center;
  display: flex;

  ${StyledAvatar} {
    height: 26px;
    width: 26px;
  }

  ${StyledName} {
    color: #4d4d4d;
    margin-left: 10px;
  }
`;

const StyledValue = styled(StyledMangerBase)`
  ${StyledAvatar} {
    height: 18px;
    width: 18px;
  }

  ${StyledName} {
    margin-left: 6px;
  }
`;

const StyledSelector = styled(Selector)`
  .${CLASS_NAME_PREFIX}__multi-value__label {
    padding-left: 4px !important;
  }
`;

export default ManagerSelector;
